import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import Logo from "../assets/lumus.svg"
import "../styles/AboutUs.scss"
import BannerHeader from '../components/BannerHeader'
const AboutUs = () => {

  useEffect(() => {
    document.title = "About Us | Lumus"; // Set the page title here
  }, []);

  return (
    <Layout>
        <div className='App'>
        <BannerHeader title={"About Us"} subtitle={""}/>
    <div className="about-container">
        <h2>WHO WE ARE</h2>
        <p>
          Lumus is the best astrology website for online Astrology predictions.
          With a gigantic pool of Psychics, Astrologers, Tarot readers, Numerologists,
          Vastu experts and more, Lumus lets you connect with these experts over call and chat
          and get answers to all your problems.
        </p>

        <p>
          On Lumus, the visitor gets the best predictions across aspects like Marriage, Love,
          Career or Health and more. When using Lumus, you can trust us for highly accurate,
          precise and well researched content that would offset most of your worries.
        </p>

        <h2>WHAT WE DO</h2>
        <p>
          Lumus brings together psychics and their boundless knowledge about the occult sciences
          on one platform and lets you connect with them 24*7. Apart from the best future predictions
          that help you get through the difficult phase of life, Lumus also offers Free Live sessions,
          Daily horoscope, Spiritual store and much more.
        </p>

        <h2>MISSION</h2>
        <p>
          Our mission is to create a community for the people who seek psychic guidance for the
          betterment of life. We want to help out people who are going through a bad phase of life
          in the most trusted way.
        </p>

        <h2>VISION</h2>
        <p>
          Our vision is to provide solutions to the customers who are facing problems.
          We want to give direction to their life with the assistance of our trusted psychics.
        </p>
      </div>
      </div>
    </Layout>
  )
}

export default AboutUs